import { API_GET_LAYOUT, API_GET_WIDGET } from '../../../../api/configurationScreenServices';
import { deleteWidgetUtil, getPublishedViewSections } from '../../../../utils/previewPaneUtils';
import { formatWidgetConfig } from '../../../../utils/globalUtils';
import { toastMessageConstants } from '../../../../constants/globalConstant';

/**
 * Fetch a homepage's layout + widget configs and return the sections ready
 * for the read-only preview (teams view). Replaces the Redux
 * getMemoizedLayout / getHomepageLayout / getWidgetConfiguration thunks.
 */
export const fetchPublishedPreviewSections = async (homepageId) => {
  const response = await API_GET_LAYOUT(homepageId);
  const { status, data } = response;
  if (status !== 200) {
    throw new Error(data?.message || toastMessageConstants.SOMETHING_WENT_WRONG);
  }

  const { hasDraftChanges, draftLayout, mobileLayout } = data;
  const layout = hasDraftChanges ? draftLayout : mobileLayout;
  let sections = layout?.sections || [];

  // Batch-fetch widget configs, 5 at a time (same as the old thunk)
  const widgetIdList = [];
  sections.forEach((section) => {
    section.rows.forEach((row) => {
      row.widgets.forEach((widget) => {
        widgetIdList.push(widget.widgetId);
      });
    });
  });

  const widgetTemplateConfigurationList = {};
  while (widgetIdList.length > 0) {
    const widgetBatch = widgetIdList.splice(0, 5);
    const widgetResponse = await Promise.allSettled(
      widgetBatch.map((widgetId) => API_GET_WIDGET(widgetId).then((res) => res?.data))
    );
    let previewPaneData = { sections };
    widgetResponse.forEach((widget, index) => {
      if (widget.value) {
        widgetTemplateConfigurationList[widget.value.widgetId] = formatWidgetConfig(
          widget.value,
          hasDraftChanges
        );
      } else {
        // Drop widgets whose config fetch failed
        previewPaneData = deleteWidgetUtil(previewPaneData, widgetBatch[index]);
        sections = previewPaneData.sections;
      }
    });
  }

  return getPublishedViewSections(sections, widgetTemplateConfigurationList);
};
